import { Logger } from '@nestjs/common';
import { NestFactory } from '@nestjs/core';
import { SwaggerModule, DocumentBuilder } from '@nestjs/swagger';
import { AppModule } from './app/app.module';
import * as bodyParser from 'body-parser';
import { ValidationPipe } from '@nestjs/common';
import * as nodemailer from 'nodemailer';
import { CommonResponseModel } from '@project-management-system/shared-models';
const shell = require('shelljs');

async function bootstrap() {
  const app = await NestFactory.create(AppModule, { logger: ['error'] });
  app.useGlobalPipes(new ValidationPipe({
    whitelist: true,
  }));
  const globalPrefix = 'api';
  app.setGlobalPrefix(globalPrefix);
  const port = Number(9036);

  const options = new DocumentBuilder()
    .setTitle('Migration System')
    .setDescription('')
    .setVersion('0.0')
    // .setBasePath(`${ptsConfigs.swagger.basePath}`)
    .addBearerAuth()
    .addTag('ms')
    .build();

  const document = SwaggerModule.createDocument(app, options);
  SwaggerModule.setup(`api`, app, document);
  app.use(bodyParser.json({ limit: '10mb' }));
  app.use(bodyParser.urlencoded({ limit: '10mb', extended: true }));
  app.enableCors();
  await app.listen(port);
  console.log(
    `🚀 Application is running on: http://localhost:${port}/${globalPrefix}`
  );
  process.on('uncaughtException', async (error) => {
    console.log(error, "UNCAUGHT EXCEPTION IN main.ts")
  
    // const recipientEmail = 'santhosh.palaksha@shahi.co.in';
    // const ccEmails = ['saiprakash.katiki@gmail.com',  'manu.gupta@shahi.co.in', 'pradeep@schemaxtech.com', 'sujatha@schemaxtech.com'];
    // const errorMessage = "Service Was stopped in Centric Please check"

    //   const transporter = nodemailer.createTransport({
    //     host: 'smtp.gmail.com',
    //     port: 587,
    //     secure: false,
    //     auth: {
    //       user: 'alerts@schemaxtech.com',
    //       pass: 'mzep lrqi mczj uezj'
    //     }
    //   });

    //   const mailOptions = {
    //     from: 'alerts@schemaxtech.com',
    //     to: recipientEmail,
    //     cc: ccEmails,
    //     subject: 'Notification: Service Stopped In Centric',
    //     html: `Dear User,<br><br>${errorMessage}.<br><br>Regards,<br><strong style="color: black;">Service Stopped BOT</strong>`,
    //   };

    //   await transporter.sendMail(mailOptions);
      console.log("Re Run New Service")
      const result = await shell.exec('npx nx serve services-common', { async: true });
      if (result.code !== 0) {
        console.log("An error passed in result need to check %%%%%%%")
      } else {
        console.log("backend command not executed ******** ")
      }
      return new CommonResponseModel(true, 1, "Notification Sent Successfully");
  })
}

bootstrap();